
import { FreelancerExperienceLevel, FreelancerSkillExperience, FreelancerToolExperience } from '../../../data_models/freelancer';

import { UserEnumTextMapper } from '../../../data_models/enumToTextMapper';
import IconButton from '../../common/IconButton';
import { MdDelete, MdDeleteOutline } from 'react-icons/md';
import TextInputField from '../../common/TextInputField';
import { OutlinedDropdownMenu } from '../../common/DropdownMenu';
import { getNumericEnumValues } from '../../../utils/enumUtils';
import { FlatButton, OutlinedButton } from '../../common/Button';

interface EditSkillExperienceProps {
    theme?: 'primary' | 'secondary',
    data: (FreelancerSkillExperience | FreelancerToolExperience)[],
    setData: (skills: (FreelancerSkillExperience | FreelancerToolExperience)[]) => void,
    type: 'skills' | 'tools',
    label?: string,
}

const EditSkillExperience: React.FC<EditSkillExperienceProps> = ({
    theme = 'primary',
    data,
    setData,
    type,
    label

}) => {

    const addExperience = () => {
        if (type === 'skills') {
            setData([...data, { skill: '', experience: FreelancerExperienceLevel.T3 }]);
        } else {
            setData([...data, { tool: '', experience: FreelancerExperienceLevel.T3 }]);
        }


    };

    return (
        <div className='flex flex-col'>
            {label && <label>{label}</label>}

            <div className='flex flex-col space-y-2'>
                {data.map((exp, index) => (
                    <div key={index} className='grid grid-cols-7 gap-2 items-center'>
                        <div className='col-span-3'>
                            <TextInputField
                                value={'skill' in exp
                                    ? (exp as FreelancerSkillExperience).skill
                                    : (exp as FreelancerToolExperience).tool}
                                onChange={(e) => {
                                    const newSkills = [...data];
                                    'skill' in exp
                                        ? (exp as FreelancerSkillExperience).skill = e.target.value
                                        : (exp as FreelancerToolExperience).tool = e.target.value

                                    setData(newSkills);
                                }}
                                placeholder="Enter your skill" />
                        </div>
                        <div className='col-span-3'>
                            <OutlinedDropdownMenu
                                options={getNumericEnumValues(FreelancerExperienceLevel)}
                                optionsToTextMapper={UserEnumTextMapper.freelancerExperienceLevel}
                                onSelect={(option) => {
                                    const newSkills = [...data];
                                    newSkills[index].experience = option as unknown as FreelancerExperienceLevel;
                                    setData(newSkills);
                                }}
                                defaultValue={exp.experience}
                            />
                        </div>

                        <IconButton
                            theme='danger'
                            icon={<MdDeleteOutline />}
                            hoverIcon={<MdDelete />}
                            onClick={() => {
                                const newSkills = [...data];
                                newSkills.splice(index, 1);
                                setData(newSkills);
                            }}
                        />
                    </div>
                ))}

            </div>
            <div className='mt-4 w-full'>

                <FlatButton
                    fullWidth
                    onClick={addExperience}>
                    {type === 'skills' ? 'Add Skill' : 'Add Tool'}
                </FlatButton>
            </div>
        </div>
    );
};

export default EditSkillExperience;
